<div class='contact-us-section row m-0'>
    <div class="content col-8">
        <p class="header">{{ "landing.gettouch" | cxTranslate }}</p>
        <p class="desc">{{ "landing.getdesc" | cxTranslate }}
            
        </p>
        <button class="vs-primary-btn" (click)="redirectToContactUs()">
            <span>{{ "landing.contactUsBtn" | cxTranslate }}</span>
        </button>
    </div>
    <!-- <div class="content-bg-img col-5"></div> -->
</div>